import { useState, useEffect } from "react";
import { firestore } from "../firebase";
import DB_PATH from "../DB_PATH";
import moment from "moment";

const formatDate = (dateString) => {
  if (!dateString) return "";
  return moment(dateString).format("D [de] MMMM [de] YYYY, HH:mm:ss [UTC]Z");
};

const useActionTracking = ({ userId }) => {
  const [actionTrackings, setActionTrackings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchActionTrackings = async () => {
      if (!userId) {
        setError("User ID is required");
        setLoading(false);
        return;
      }

      try {
        const actionTrackingSnapshot = await firestore
          .collection(DB_PATH.USER)
          .doc(userId)
          .collection(DB_PATH.ACTION_TRACKING)
          .get();

        const formattedActionTrackings = actionTrackingSnapshot.docs.map(
          (doc) => {
            const data = doc.data();
            return {
              id: doc.id,
              actionId: data.actionId,
              date: formatDate(data.date),
              feedback: data.feedback || "",
              habitId: data.habitId,
              notes: data.notes || "",
              title: data.title,
              progressTracking: data.progressTracking || [],
              subactionIds: data.subactionIds || [],
              ...data, // Include any other fields that might be present
            };
          }
        );

        setActionTrackings(formattedActionTrackings);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching action trackings: ", err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchActionTrackings();
  }, [userId]);

  return { actionTrackings, loading, error };
};

export default useActionTracking;
